// A small curated spotlight of especially well-known McDonalds.
// Portraits are symbolic engraved crest medallions (by field) — not photographs of the individuals.
export const FEATURED = [
  {
    name: "Sir Arthur B. McDonald",
    life: "*1943",
    role: "Physicist",
    note: "Nobel Prize-winning Canadian physicist (2015).",
    emblem: "https://static.prod-images.emergentagent.com/jobs/bde484a9-e96e-490f-b5b9-ebd46eea8e7e/images/7b1ee80912e10abdb926e422f9ec026299c3bb1f6fdda8c0a5e0625eb09b4be3.jpeg",
  },
  {
    name: "Audra McDonald",
    life: "*1970",
    role: "Actress & Singer",
    note: "Record-setting American Broadway performer.",
    emblem: "https://static.prod-images.emergentagent.com/jobs/bde484a9-e96e-490f-b5b9-ebd46eea8e7e/images/4603a65bee370fe45d7fc190231a719aef980ba82b6472bda083dab52ee1734a.jpeg",
  },
  {
    name: "Michael McDonald",
    life: "*1952",
    role: "Musician",
    note: "Grammy-winning American singer-songwriter.",
    emblem: "https://static.prod-images.emergentagent.com/jobs/bde484a9-e96e-490f-b5b9-ebd46eea8e7e/images/920aee3dc4a12e6b97a5b1c48880be89c2ab0b9d6a38c9722c766c4484f80ecd.jpeg",
  },
  {
    name: "Sir Trevor McDonald",
    life: "*1939",
    role: "Broadcaster",
    note: "Pioneering British television newsreader.",
    emblem: "https://static.prod-images.emergentagent.com/jobs/bde484a9-e96e-490f-b5b9-ebd46eea8e7e/images/2172dfc2ad9bc3befd57cf8222f59e2b6afd9d375e7795b513a87aaf182939cc.jpeg",
  },
  {
    name: "Maurice McDonald",
    life: "1902–1971",
    role: "Entrepreneur",
    note: "Co-founder of the original McDonald's drive-in.",
    emblem: "https://static.prod-images.emergentagent.com/jobs/bde484a9-e96e-490f-b5b9-ebd46eea8e7e/images/a30baa9116faa93e3bd1cd8c517aba537e7087bb1dd3d008afe16a6fbf89694b.jpeg",
  },
  {
    name: "Lanny McDonald",
    life: "*1953",
    role: "Ice Hockey",
    note: "Canadian Hockey Hall of Fame legend.",
    emblem: "https://static.prod-images.emergentagent.com/jobs/bde484a9-e96e-490f-b5b9-ebd46eea8e7e/images/967e923465a2c156ea33285568437ac6427ee5e6edbb53802966b80788f7ab56.jpeg",
  },
];
